import React from 'react';
import ButtonsGeneric from '../ButtonsGeneric';
import InputText from '../InputText';
import { TableCalcStyle, WrapperTables } from '../TableCalcCompStyle';

export default function TableCalcCompOutDesVar() {
  return (
    <WrapperTables>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>ID</th>
            <th>Descrição da Despesa</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
              <InputText title="" id="NomeDosProfissionais1" widthPercentage="100%" />
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
      <ButtonsGeneric>
        <button className="success">+ Adicionar</button>
      </ButtonsGeneric>
      <h3>Despesas Variáveis</h3>
      <TableCalcStyle>
        <thead>
          <tr>
            <th>ID</th>
            <th>ago/21</th>
            <th>set/21</th>
            <th>out/21</th>
            <th>nov/21</th>
            <th>dez/21</th>
            <th>jan/22</th>
            <th>fev/22</th>
            <th>mar/22</th>
            <th>abr/22</th>
            <th>mai/22</th>
            <th>jun/22</th>
            <th>jul/22</th>
            <th>Outros</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <input type="text" className="UnitValueInput" />
            </td>
            <td>
              <p className="Total">R$ 0,00</p>
            </td>
          </tr>
        </tbody>
      </TableCalcStyle>
    </WrapperTables>
  );
}
